"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPrintable;
const uuid_1 = require("uuid");
const Printable_1 = require("../../models/printables/Printable");
const either_1 = require("../../types/either");
const getTemplateSurface_1 = require("./getTemplateSurface");
function createPrintable(userId, projectId, designId, layers, template, printableId) {
  let creationDate = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : new Date().toISOString();
  let printableGroupType = arguments.length > 7 ? arguments[7] : undefined;
  const id = printableId || (0, uuid_1.v4)();
  const surface = (0, getTemplateSurface_1.getTemplateSurface)({
    template,
    printableGroupType
  });
  const printable = {
    id,
    parentId: projectId,
    createdAt: creationDate,
    lastModifiedAt: creationDate,
    version: (0, Printable_1.generatePrintableVersion)(creationDate, id),
    lastModifiedBy: userId,
    lastModifiedByAdmin: false,
    surface,
    designId,
    isCompositeDesign: designId.split('|').length > 1,
    // Composite design ids look like `left_design|right_design`
    layers
  };
  return (0, either_1.right)(printable);
}